/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeActions from "../../models/store/storeActions";
import * as storeEffects from "../../models/store/storeEffects";
import { EventList, IEventListOwnProps, IEventListStateProps, IEventListDispatchProps } from "../../components/event/eventList";
import { Base } from "ui/Scripts/source/framework/base";

export function mapStateToProps(applicationState: IApplicationState, ownProps: IEventListOwnProps): IEventListStateProps {
    if (Base.isNullOrUndefined(applicationState) || Base.isNullOrUndefined(applicationState.event) || Base.isNullOrUndefined(applicationState.event.eventList)) {
        return {
            user: null,
            hasMore: true,
            isLoading: false,
            page: 0,
            items: [],
            state: 0,
            startDate: null,
            endDate: null,
            unitId: null,
            units: [],
            sortColumn: "",
            lastOpenedEventId: ""
        };
    }
    const eventList = applicationState.event.eventList;
    return {
        user: applicationState.user,
        hasMore: eventList.hasMore,
        isLoading: eventList.isLoading,
        page: eventList.page,
        items: eventList.items,
        state: eventList.state,
        startDate: eventList.startDate,
        endDate: eventList.endDate,
        unitId: eventList.unitId,
        units: eventList.units,
        sortColumn: eventList.sortColumn,
        lastOpenedEventId: eventList.lastOpenedEventId,
    };
}

export function mapDispatchToProps(dispatch: storeEffects.EventThunkDispatch): IEventListDispatchProps {
    return {
        loadEvents: (page: number, state: number, startDate: number, endDate: number, unitId: string) => dispatch(storeEffects.getEventList(page, state, startDate, endDate, unitId)),
        removeEvent: (id: string) => dispatch(storeActions.eventListRemove(id)),
        resetEvents: () => dispatch(storeActions.eventListReset()),
        refreshEvents: (page: number, state: number, startDate: number, endDate: number, unitId: string) => dispatch(storeEffects.eventListRefresh(page, state, startDate, endDate, unitId)),
        setLastOpenedEventId: (id: string) => dispatch(storeActions.eventListSetLastOpened(id)),
        setReturnUrl: (url: string) => dispatch(storeActions.eventEditSetReturnUrl(url)),
        onLogout: () => dispatch(storeEffects.logout())
    };
}

export default connect<IEventListStateProps, IEventListDispatchProps, IEventListOwnProps>(mapStateToProps, mapDispatchToProps)(EventList);